import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StringToArrayPipeModule } from '@shared/core/pipes/stringToArray';
import { CardNoPipeModule } from '@shared/core/pipes/cardNo';
import { CardVisualizerComponent } from './card-visualizer.shared.component';

@NgModule({
    declarations: [
        CardVisualizerComponent
    ],
    imports: [
        CommonModule,
        StringToArrayPipeModule,
        CardNoPipeModule,
    ],
    exports: [
        CardVisualizerComponent
    ],
    providers: [],
})
export class CardVisualizerModule { }
